import styled from '@emotion/styled';

const WhiteContainer = styled.div`
  background: #ffffff;
  border: 1px solid #d3dce0;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2px;
`;

export default WhiteContainer;
